<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import moment from "moment";
import VueSweetalert2 from "vue-sweetalert2";
import ErrorMessage from "../../components/error-message";

/**
 * Basic-table component
 */
export default {
  components: { ErrorMessage,Layout, PageHeader },
  data() {
    return {
      title: "Markup Commission List",
      items: [
        {
          text: "Commission",
          href: "/",
        },
        {
          text: "Markup Commission List",
          active: true,
        },
      ],
      mcs: [],
        errors:null,
        visible:false,
        message:"",
        search:"",
    };
  },
  mounted() {
    this.getMCList();
  },
    computed: {
        filteredList() {
            return this.mcs.filter(mc => {
                return mc.uuid.toLowerCase().includes(this.search.toLowerCase())

            })
        }
    },
  methods: {
      onClose(){
          this.visible=false;
      },
      searchFilterFunc2(val) {
          this.search=val;
      },

      moment: function () {
      return moment();
    },
    async getMCList() {
      try {
        axios
          .get("/api/markup_com/list", {
            params: {
              accessToken: localStorage.getItem("access_tocken"),
            },
          })
          .then((response) => {
            if (response.data.status) {
              this.mcs = response.data.data;
            } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              this.errorCheck(jsonParse);
            }
          })
          .catch((error) => {
            console.log(error.message);
          });
      } catch (err) {
        console.log(err);
      }
    },
      async duplicateWarning(mc) {
          var _this = this;
          try {
              this.$swal({
                  title: "Are you sure?",
                  text: "You can't revert your action",
                  type: "error",
                  showCancelButton: true,
                  confirmButtonText: "Yes, duplicate this row!",
                  cancelButtonText: "No",
                  showCloseButton: true,
                  showLoaderOnConfirm: true,
              }).then((result) => {
                  if (result.value) {
                      _this.duplicateItem(mc);
                  } else {
                      this.$swal("Cancelled", "", "info");
                  }
              });
          } catch (err) {
              console.log(err);
          }
      },
      duplicateItem(mc) {
          axios
              .post("/api/markup_com/create", {
                  start_dateTime: mc.start_dateTime,
                  end_dateTime:mc.end_dateTime,
                  origin: mc.origin,
                  destination: mc.destination,
                  api_id: mc.api_id,
                  airline_code: mc.airline_code,
                  agent_type: mc.agent_type,
                  journey_type: mc.journey_type,
                  user_role_id: mc.user_role_id,
                  user_id: mc.user_id,
                  markup_type: mc.markup_type,
                  markup_value: mc.markup_value,
                  commission_type: mc.commission_type,
                  commission_value: mc.commission_value,
                  apply_advanced_rules: mc.apply_advanced_rules,
                  exclude_origin: mc.exclude_origin,
                  exclude_airport: mc.exclude_airport,
                  exclude_class: mc.exclude_class,
                  exclude_trip_type: mc.exclude_trip_type,
                  exclude_fare_type: mc.exclude_fare_type,
                  include_flight_type: mc.include_flight_type,
                  extra_commission_type: mc.extra_commission_type,
                  economy_extra_commission: mc.economy_extra_commission,
                  business_extra_commission: mc.business_extra_commission,
                  exclude_soto: mc.exclude_soto,
                  exclude_oal_fare: mc.exclude_oal_fare,
                  is_domestic: mc.is_domestic,
                  is_lcc: mc.is_lcc,
                  accessToken: localStorage.getItem("access_tocken"),
              })
              .then((response) => {
                  if (response.data.status) {
                      this.$swal("Good job!", "Markup Commission row duplicated", "success");
                      this.getMCList();
                  } else {
                      var str = response.data.message;
                      var jsonParse = JSON.parse(str);
                      this.errorCheck(jsonParse);
                  }
              })
              .catch((error) => {
                  if (error.response != undefined) {
                      this.errors = error.response.data.errors;
                  }
              });
      },
    async deleteWarning(mc) {
      var _this = this;
      try {
        this.$swal({
          title: "Are you sure?",
          text: "You can't revert your action",
          type: "error",
          showCancelButton: true,
          confirmButtonText: "Yes, Delete it!",
          cancelButtonText: "No",
          showCloseButton: true,
          showLoaderOnConfirm: true,
        }).then((result) => {
          if (result.value) {
            _this.deleteItem(mc);
          } else {
            this.$swal("Cancelled", "", "info");
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    deleteItem: function deleteItem(mc) {
      var _this = this;
      axios
        .post("/api/markup_com/delete/" + mc.uuid, {
          accessToken: localStorage.getItem("access_tocken"),
        })
        .then(function (response) {
            if(response.data.status){
                _this.$swal.fire({
                    position: 'top-end',
                    icon: 'error',
                    title: 'Successfully Delete Flight DMC',
                    showConfirmButton: false,
                    timer: 1000
                });
                // _this.getAgentList();
                // _this.hasDeleted = false;
                _this.getMCList();
                _this.hasDeleted = false;
            } else {
                var str = response.data.message;
                var jsonParse = JSON.parse(str);
                _this.errorCheck(jsonParse);
            }
        });
    },
    errorCheck(obj) {
        if(obj.statusCode == 403){
            this.visible=true;
            this.message="Access Permission Denied";
            this.errors = obj.message;
        }else if (obj.error) {
        this.errors = obj.message;
      } else if (obj.message == "Token has expired") {
          this.$swal.fire({
              title: 'LogOut!',
              text: 'Token Has Expired',
              icon: 'error',
              toast:'true',
              position: 'top-end',
          });
        this.$router.push({ name: "logout" });
      } else if (obj.message !== "Token has expired") {
        this.errors = obj.message;
      } else {
        this.flashMessage.show({
          time: 5000,
          status: "error",
          title: "Error",
          message: "Problem in data save",
        });
      }
    },
  },
};
</script>

<template>
  <Layout  @CustomEventInputChangedAll="searchFilterFunc2">
    <PageHeader :title="title" :items="items" />
      <ErrorMessage :visible="visible" :errors="errors" v-on:close="onClose" :message="message"/>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="table-responsive table-sm">
              <table class="table mb-0 table-striped">
                <thead>
                  <tr>
                    <th>SL</th>
                    <th>Start DateTime</th>
                    <th>End DateTime</th>
                    <th>Origin</th>
                    <th>Destination</th>
                    <th>Airline Code</th>
                      <th>Api Id</th>
                    <th>Apply Advanced Rules</th>
                      <th> Is Domestic</th>
                      <th> Is Lcc</th>
                    <th>Journey Type</th>
                    <th>User Type</th>
                    <th>markup Type</th>
                    <th>Markup Value</th>
                    <th>Commission Type</th>
                    <th>Commission Value</th>
                    <th>Exclude Origin</th>
                    <th>Exclude Airport</th>
                    <th>Exclude Class</th>
                    <th>Exclude Trip Type</th>
                    <th>Exclude Fare Type</th>
                    <th>Include Flight Type</th>
                    <th>Extra Commission Type</th>
                    <th>Economy Extra Commission</th>
                    <th>Business Extra Commission</th>
                    <th>Exclude Soto</th>
                    <th>Exclude Oal Fare</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(mc,index) in filteredList" v-bind:key="index">
                    <th scope="row">{{index+1}}</th>
                    <td>{{ mc.start_dateTime | moment('"D MMM YYYY, H:mm"')}}</td>
                    <td>{{ mc.end_dateTime==null ? 'continue' : mc.end_dateTime | moment("D MMM YYYY, H:mm")}}</td>
                    <td>{{mc.origin==null ? 'all' : mc.origin}}</td>
                    <td>{{mc.destination==null ? 'all' : mc.destination}}</td>
                      <td>{{mc.airline_code}}<span v-if="mc.airline_code==null">all</span></td>
                      <td>{{mc.api_vendor==null ? 'all' : mc.api_vendor.api_provider}}</td>
                    <td>{{mc.apply_advanced_rules==true ? 'Yes' : 'No'}}</td>
                      <td>{{mc.is_domestic==0 ? 'No' :'Yes'}}</td>
                      <td>{{mc.is_lcc==0 ? 'No' : 'Yes'}}</td>
                    <td>{{mc.journey_type}}<span v-if="mc.journey_type==null">all</span></td>
                    <td>{{mc.user_type}}<span v-if="mc.user_type==null">all</span></td>
                    <td>{{mc.markup_type==null ? 'none' : mc.markup_type}}</td>
                    <td>{{mc.markup_value==null ? 'none' : mc.markup_value}}</td>
                    <td>{{mc.commission_type==null ? 'none' : mc.commission_type}}</td>
                    <td>{{mc.commission_value== null ? 'none' : mc.commission_value}}</td>
                    <td>{{mc.exclude_origin}}<span v-if="mc.exclude_origin==null">none</span></td>
                    <td>{{mc.exclude_airport}}<span v-if="mc.exclude_airport==null">none</span></td>
                    <td>{{mc.exclude_class}}<span v-if="mc.exclude_class==null">none</span></td>
                    <td>{{mc.exclude_trip_type}}<span v-if="mc.exclude_trip_type==null">none</span></td>
                    <td>{{mc.exclude_fare_type}}<span v-if="mc.exclude_fare_type==null">none</span></td>
                    <td>{{mc.include_flight_type}}<span v-if="mc.include_flight_type==null">none</span></td>
                    <td>{{mc.extra_commission_type}}<span v-if="mc.extra_commission_type==null">none</span></td>
                    <td>{{mc.economy_extra_commission}}<span v-if="mc.economy_extra_commission==null">none</span></td>
                    <td>{{mc.business_extra_commission}}<span v-if="mc.business_extra_commission==null">none</span></td>
                    <td>{{mc.exclude_soto}}<span v-if="mc.exclude_soto==null">none</span></td>
                    <td>{{mc.exclude_oal_fare}}<span v-if="mc.exclude_oal_fare==null">none</span></td>
                    <td><router-link :to="{ name: 'markup_update', params: {uuid: mc.uuid } }" class="btn btn-primary btn-sm"><i class="fas fa-edit"></i> Edit</router-link> <button @click.prevent="deleteWarning(mc)" class="btn btn-danger btn-sm"><i class="fa fa-trash"></i> Delete</button>
                        <button @click.prevent="duplicateWarning(mc)" class="btn btn-primary btn-sm"> Duplicate</button></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
